'use client';

import React, { useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { 
  PasswordInput, 
  Button, 
  Stack, 
  Paper, 
  Title 
} from '@mantine/core'

export const PasswordChange: React.FC = () => {
  const { updateUserPassword } = useAuth()
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    try {
      await updateUserPassword(currentPassword, newPassword)
      alert('Password updated successfully')
      setCurrentPassword('')
      setNewPassword('')
    } catch (error) {
      alert(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Paper radius="md" p="xl" withBorder>
      <Title order={3} mb="md">Change Password</Title>
      <form onSubmit={handleSubmit}>
        <Stack>
          <PasswordInput
            required
            label="Current Password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            radius="md"
          />
          <PasswordInput
            required
            label="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            radius="md"
          />
          <Button 
            type="submit" 
            loading={loading}
            radius="md"
          >
            Update Password
          </Button>
        </Stack>
      </form>
    </Paper>
  )
} 